import React from "react";
import { useTranslation } from "react-i18next";

const AttentionGeneralTitle = ({ metricValue }) => {
  const { t } = useTranslation();

  return <>{metricValue > 1 ? <span>{t("Greate news")}</span> : <span>{t("All good")}</span>}</>;
};

export default AttentionGeneralTitle;
